import { initialAppState } from '../models/state/appState';
import { MvnoBundle, MvnoBundleState } from '../models/state/mvnoBundle';
import { LOAD_MVNO_BUNDLE_PENDING, LOAD_MVNO_BUNDLE_FAILURE, LOAD_MVNO_BUNDLE_SUCCESS } from '../actions/actionTypes';

export default function mvnoBundleReducer(
  state: MvnoBundleState = initialAppState.mvnoBundle,
  action: any,
): MvnoBundleState {
  switch (action.type) {
    case LOAD_MVNO_BUNDLE_PENDING: {
      return {
        Id: 0,
        Msisdn: '',
        CreatedOnUtc: new Date(),
        StartDateUtc: new Date(),
        RenewalDateUtc: new Date(),
        ExpirationDateUtc: new Date(),
        Period: 'unknown',
        AllowanceMB: 0,
        isLoading: true,
        Status: 'unknown',
        Topups: null,
      };
    }
    case LOAD_MVNO_BUNDLE_FAILURE: {
      const serialNo = action.payload as string;
      if (!serialNo) {
        return state;
      }

      return {
        Id: 0,
        Msisdn: '',
        CreatedOnUtc: new Date(),
        StartDateUtc: new Date(),
        RenewalDateUtc: new Date(),
        ExpirationDateUtc: new Date(),
        Period: 'unknown',
        AllowanceMB: 0,
        isLoading: false,
        Status: 'unknown',
        Topups: null,
      };
    }

    case LOAD_MVNO_BUNDLE_SUCCESS: {
      const bundle = action.payload as MvnoBundle;
      if (!bundle) {
        return state;
      }

      const newState: MvnoBundleState = {
        Id: bundle.Id,
        Msisdn: bundle.Msisdn,
        CreatedOnUtc: bundle.CreatedOnUtc,
        StartDateUtc: bundle.StartDateUtc,
        RenewalDateUtc: bundle.RenewalDateUtc,
        ExpirationDateUtc: bundle.ExpirationDateUtc,
        Period: bundle.Period,
        AllowanceMB: bundle.AllowanceMB,
        isLoading: false,
        Status: bundle.Status,
        Topups: bundle.Topups,
      };

      return newState;
    }
    default:
      return state;
  }
}
